import { render, staticRenderFns } from "./ApeironCommissions.vue?vue&type=template&id=a3cf9f18"
import script from "./ApeironCommissions.vue?vue&type=script&lang=js"
export * from "./ApeironCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports